<template>
  <path
    d="M23.64 7.00024C23.19 6.66024 18.71 3.00024 12 3.00024C5.27999 3.00024 0.809985 6.66024 0.359985 7.00024L10.44 19.5602C11.24 20.5602 12.76 20.5602 13.56 19.5602L23.64 7.00024Z"
  />
</template>
